import typeaheadPopupTemplate from './typeahead-popup-override.html';

TnStoreTypeaheadConfig.$inject = ['$provide'];
export function TnStoreTypeaheadConfig($provide) {
    function TnStoreTypeaheadTemplateOverrideDecorator($delegate) {
        const directive = $delegate[0];
        // TODO: update all usages of uib-typeahead to set the property typeahead-popup-template-url
        // instead of overriding through the provider. alternatively we could build a wrapper around the directive
        // but need to consider the additional markup and design impact of wrapping in <tn-popup></tn-popup>
        directive.templateUrl =
            'typeahead-template-override.decorator/typeahead-popup-override.html';
        return $delegate;
    }
    TnStoreTypeaheadTemplateOverrideDecorator.$inject = ['$delegate'];
    $provide.decorator(
        'uibTypeaheadPopupDirective',
        TnStoreTypeaheadTemplateOverrideDecorator
    );
}

export function populateTemplateCache($templateCache) {
    // Inject in templateCache so it can be referenced via templateUrl.
    $templateCache.put(
        'typeahead-template-override.decorator/typeahead-popup-override.html',
        typeaheadPopupTemplate
    );
}
populateTemplateCache.$inject = ['$templateCache'];
